import {
  capitolo1, capitolo2, capitolo3, capitolo4, capitolo5, capitolo6,
} from './chapter';
import { sottocapitolo1, sottocapitolo2 } from './subchapter';

export default [
  capitolo1,
  sottocapitolo1,
  sottocapitolo2,
  capitolo2,
  capitolo3,
  capitolo4,
  capitolo5,
  capitolo6,

];
